define('shoppingCartService',["jquery", "eventManager", 'cartService', 'SageDotCom/DataLayer/tealium', 'SageDotCom/DataLayer/Util/trackingHelper'],
    function ($, eventManager, cartService, tealium, trackingHelper) {

        function ShoppingCartService() {
            Object.defineProperty(this, 'pricePromise', { enumerable: !0, writable: !0, configurable: !0, value: cartService.init() });
        }

        ShoppingCartService.prototype.getProductCart = function (personaId) {
            return this.pricePromise.then(function() {
                return cartService.getProductCart(personaId)
                                  .then(function(data) {
                                        eventManager.trigger("Sage:GetCart", data);
                                        return data;
                                  }).catch(function(err) {
                                        console && console.error(err);
                                        console && console.error("Error on get product cart");
                                  });
            });
        };

        ShoppingCartService.prototype.calculateCart = function (cart) {

            return this.pricePromise.then((function (cart) {
                return cartService.calculate(cart)
                                  .then(function (data) {
                                        eventManager.trigger("Sage:CartCalculated", data);
                                  })
                                  .catch(function (err) {
                                      console && console.error(err);
                                      console && console.error("Error on cart calculation");
                                  });
                }).bind(this, cart), function(err) {
                    console && console.error(err);
                    console && console.error("Failed to retrieve pricing");
                });
        };

        ShoppingCartService.prototype.checkout = function (persona, cartObject, callbackUrl) {

            cartService.checkout(persona, cartObject, callbackUrl).then(function (data) {
                eventManager.trigger("Sage:CartCheckout", data);
            }).catch(function(err) {
                console.error(err);
                console.error("Error on cart checkout");
            });
        };

        return new ShoppingCartService();
    });
